export enum SignupStep {
  CHECK_EMAIL = 'CHECK_EMAIL',
  CREATE_USERNAME = 'CREATE_USERNAME',
  REGISTER = 'REGISTER',
  FINISH = 'FINISH'
}
